// src/store/modules/portfolio/actions.js

import { get, post } from '@/services/api';

export default {
  async getCoveredCallSetup() {
    try {
      const response = await get('/coveredcall/get-covered-call-setup');
      return response.data;
    } catch (err) {
      console.error('getCoveredCallSetup failed', err);
      throw err;
    }
  },

  async getWeeklyRolloverSetup(context, portfolioId) {
    try {
      const response = await get(`/coveredcall/get-weekly-rollover-setup`, {
        params: { portfolioId }
      });
      return response.data;
    } catch (err) {
      console.error('getWeeklyRolloverSetup failed', err);
      throw err;
    }
  },

  async getMonthlyRolloverSetup(context, portfolioId) {
    try {
      const response = await get(`/coveredcall/get-monthly-rollover-setup`, {
        params: { portfolioId }
      });
      return response.data;
    } catch (err) {
      console.error('getMonthlyRolloverSetup failed', err);
      throw err;
    }
  },

  async getUpperThresholdSetup(context, portfolioId) {
    try {
      const response = await get(`/coveredcall/get-upper-threshold-setup`, {
        params: { portfolioId }
      });
      return response.data;
    } catch (err) {
      console.error('getUpperThresholdSetup failed', err);
      throw err;
    }
  },

  async getUpperThresholdRevertSetup(context, portfolioId) {
    try {
      const response = await get(`/coveredcall/get-upper-threshold-revert-setup`, {
        params: { portfolioId }
      });
      return response.data;
    } catch (err) {
      console.error('getUpperThresholdRevertSetup failed', err);
      throw err;
    }
  },

  async getLowerThresholdSetup(context, portfolioId) {
    try {
      const response = await get(`/coveredcall/get-lower-threshold-setup`, {
        params: { portfolioId }
      });
      return response.data;
    } catch (err) {
      console.error('getLowerThresholdSetup failed', err);
      throw err;
    }
  },

  async getLowerThresholdRevertSetup(context, portfolioId) {
    try {
      const response = await get(`/coveredcall/get-lower-threshold-revert-setup`, {
        params: { portfolioId }
      });
      return response.data;
    } catch (err) {
      console.error('getLowerThresholdRevertSetup failed', err);
      throw err;
    }
  },

  async getNextStage() {
    try {
      const response = await get('/coveredcall/get-next-stage');
      return response.data;
    } catch (err) {
      console.error('getNextStage failed', err);
      throw err;
    }
  },
  
  async executeInitialSetup({ commit }, payload) {
    try {
      const res = await post('/coveredcall/execute-initial-setup', {
        initSetup: payload.initSetup
      });
      return res.data;
    } catch (err) {
      console.error('executeInitialSetup failed', err);
      throw err;
    }
  },

  async executeNextStage({ commit }, payload) {
    try {
      const res = await post('/coveredcall/execute-next-stage', {
        coverredCallNextStage: payload.coverredCallNextStage
      });
      return res.data; // Returns { coverredCallNextStage, executed, msg }
    } catch (err) {
      console.error('executeNextStage failed', err);
      throw err;
    }
  },

  async executeBullPutSpread({ commit }) {
    try {
      const res = await post('/coveredcall/execute-bull-put-spread');
      return res.data;
    } catch (err) {
      console.error('executeBullPutSpread failed', err);
      throw err;
    }
  },

  async exitBullPutSpread({ commit }) {
    try {
      const res = await post('/coveredcall/exit-bull-put-spread');
      return res.data;
    } catch (err) {
      console.error('exitBullPutSpread failed', err);
      throw err;
    }
  },

  async executeNegativeRatio({ commit }) {
    try {
      const res = await post('/coveredcall/execute-negative-ratio');
      return res.data;
    } catch (err) {
      console.error('executeNegativeRatio failed', err);
      throw err;
    }
  },

  async exitNegativeRatio({ commit }) {
    try {
      const res = await post('/coveredcall/exit-negative-ratio');
      return res.data;
    } catch (err) {
      console.error('exitNegativeRatio failed', err);
      throw err;
    }
  },

  async rolloverNegativeRatio({ commit }) {
    try {
      const res = await post('/coveredcall/rollover-negative-ratio');
      return res.data;
    } catch (err) {
      console.error('rolloverNegativeRatio failed', err);
      throw err;
    }
  },

  async upshiftNegativeRatio({ commit }) {
    try {
      const res = await post('/coveredcall/upshift-negative-ratio');
      return res.data;
    } catch (err) {
      console.error('upshiftNegativeRatio failed', err);
      throw err;
    }
  }
};